import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import useTheme from "./useTheme";
import Modal from "react-bootstrap/Modal";

const Report = (props) => {
  const [theme, switchTheme] = useTheme();

  const [showReport, setShowReport] = useState(false);

  const [reportKala, setReportKala] = useState({});

  useEffect(() => {
    const form = new FormData();
    form.append("getReport", 1);
    form.append("type", "kala");
    form.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setReportKala(data.data);
        console.log(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  return (
    <>
      <Nav.Link
        onClick={() => {
          setShowReport(true);
        }}
        href="#"
        className={theme === "light" ? "text-dark" : "text-light"}
      >
        گزارش
      </Nav.Link>

      <Modal
        show={showReport}
        onHide={() => setShowReport(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark rtl justify-content-center"
              : "rtl justify-content-center bg-dark text-light"
          }
        >
          گزارشات
        </Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <div className="row rtl">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="profile-item">
                {/* <FontAwesomeIcon icon={faUser} /> */}
                {" تعداد کالاهای ویترین : " + reportKala.totalKalaNum}
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="profile-item">
                {/* <FontAwesomeIcon icon={faMobileAlt} /> */}
                {" تعداد کالای مهمان : " + reportKala.guestNum}
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="profile-item">
                {/* <FontAwesomeIcon icon={faMobileAlt} /> */}
                {" تعداد کالای خصوصی : " + reportKala.pvNum}
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="profile-item">
                {/* <FontAwesomeIcon icon={faMobileAlt} /> */}
                {" تعداد کالای پاک شده : " + reportKala.deletedNum}
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="profile-item">
                {/* <FontAwesomeIcon icon={faMobileAlt} /> */}
                {" تعداد اینفوگرافی ها : " + reportKala.infographNum}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button className="btn btn-dark" onClick={() => setShowReport(false)}>
            بستن
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Report;
